import { render, staticRenderFns } from "./TftPublicBrackets.vue?vue&type=template&id=bc896eac&scoped=true"
import script from "./TftPublicBrackets.vue?vue&type=script&lang=js"
export * from "./TftPublicBrackets.vue?vue&type=script&lang=js"
import style0 from "./TftPublicBrackets.vue?vue&type=style&index=0&id=bc896eac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc896eac",
  null
  
)

export default component.exports